import React, { useState } from 'react';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: ''
    });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await fetch('http://localhost:5000/api/dashboard/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            setSubmitted(true);
        } catch (err) {
            alert('Message submit nahi hua. Dobara try karo.');
        }
    };

    return (
        <main className="bg-dark-300 min-h-screen">

            {/* ── HERO ── */}
            <section className="relative max-w-7xl mx-auto px-4 pt-20 pb-16 text-center">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-saffron-500 opacity-10 rounded-full blur-3xl pointer-events-none" />

                <p className="text-saffron-500 font-semibold tracking-widest text-sm uppercase mb-4">
                    हमसे बात करो
                </p>
                <h1 className="font-display text-4xl md:text-5xl font-bold text-white mb-6">
                    कोई भी सवाल हो <br />
                    <span className="text-saffron-500">हम यहाँ हैं</span>
                </h1>
                <p className="text-gray-400 text-lg max-w-xl mx-auto">
                    Job से related कोई भी problem हो, form भरने में दिक्कत हो —
                    हमसे directly contact करो।
                </p>
            </section>

            {/* ── CONTACT GRID ── */}
            <section className="max-w-7xl mx-auto px-4 pb-24">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">

                    {/* Left — Contact Info */}
                    <div className="flex flex-col gap-6">

                        <div className="bg-dark-200 border border-gray-800 rounded-2xl p-6 flex items-start gap-4">
                            <div className="text-3xl">📞</div>
                            <div>
                                <h4 className="text-white font-semibold mb-1">Phone / WhatsApp</h4>
                                <p className="text-saffron-500 font-medium">+91 98765 43210</p>
                                <p className="text-gray-500 text-sm mt-1">Mon–Sat, 9am – 6pm</p>
                            </div>
                        </div>

                        <div className="bg-dark-200 border border-gray-800 rounded-2xl p-6 flex items-start gap-4">
                            <div className="text-3xl">📧</div>
                            <div>
                                <h4 className="text-white font-semibold mb-1">Email</h4>
                                <p className="text-saffron-500 font-medium">support@jobfreedom.in</p>
                                <p className="text-gray-500 text-sm mt-1">24 घंटे में reply</p>
                            </div>
                        </div>

                        <div className="bg-dark-200 border border-gray-800 rounded-2xl p-6 flex items-start gap-4">
                            <div className="text-3xl">📍</div>
                            <div>
                                <h4 className="text-white font-semibold mb-1">Office Address</h4>
                                <p className="text-gray-400 text-sm leading-relaxed">
                                    JobFreedom Pvt. Ltd.<br />
                                    Gandhi Maidan Road, Patna<br />
                                    Bihar — 800001
                                </p>
                            </div>
                        </div>

                        <div className="bg-dark-200 border border-gray-800 rounded-2xl p-6 flex items-start gap-4">
                            <div className="text-3xl">💬</div>
                            <div>
                                <h4 className="text-white font-semibold mb-1">WhatsApp Group</h4>
                                <p className="text-gray-400 text-sm mb-3">
                                    Latest job updates ke liye humara WhatsApp group join karo
                                </p>
                                <button className="bg-green-600 hover:bg-green-700 text-white text-sm font-semibold px-4 py-2 rounded-full transition">
                                    Join WhatsApp Group
                                </button>
                            </div>
                        </div>

                    </div>

                    {/* Right — Contact Form */}
                    <div className="bg-dark-200 border border-gray-800 rounded-3xl p-8">

                        {submitted ? (
                            <div className="text-center py-16">
                                <div className="text-6xl mb-6">✅</div>
                                <h3 className="font-display text-2xl font-bold text-white mb-3">
                                    Message भेज दिया!
                                </h3>
                                <p className="text-gray-400">
                                    हम जल्द ही आपसे contact करेंगे।
                                </p>
                                <button
                                    onClick={() => setSubmitted(false)}
                                    className="mt-6 text-saffron-500 hover:text-saffron-400 text-sm underline"
                                >
                                    दूसरा message भेजो
                                </button>
                            </div>
                        ) : (
                            <>
                                <h3 className="font-display text-2xl font-bold text-white mb-8">
                                    Message भेजो
                                </h3>

                                <form onSubmit={handleSubmit} className="flex flex-col gap-5">

                                    <div>
                                        <label className="text-gray-400 text-sm mb-2 block">
                                            पूरा नाम *
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            required
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder="Rahul Kumar"
                                            className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                                        />
                                    </div>

                                    <div>
                                        <label className="text-gray-400 text-sm mb-2 block">
                                            Phone Number *
                                        </label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            required
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder="98765 43210"
                                            className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                                        />
                                    </div>

                                    <div>
                                        <label className="text-gray-400 text-sm mb-2 block">
                                            Email (optional)
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="rahul@gmail.com"
                                            className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                                        />
                                    </div>

                                    <div>
                                        <label className="text-gray-400 text-sm mb-2 block">
                                            Message *
                                        </label>
                                        <textarea
                                            name="message"
                                            required
                                            rows={4}
                                            value={formData.message}
                                            onChange={handleChange}
                                            placeholder="आपका सवाल यहाँ लिखो..."
                                            className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600 resize-none"
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="bg-saffron-500 hover:bg-saffron-600 text-white font-semibold py-4 rounded-full transition shadow-lg shadow-saffron-500/30"
                                    >
                                        Message भेजो →
                                    </button>

                                </form>
                            </>
                        )}
                    </div>

                </div>
            </section>

            {/* ── FAQ ── */}
            <section className="bg-dark-200 py-20">
                <div className="max-w-3xl mx-auto px-4">
                    <h2 className="font-display text-3xl font-bold text-white text-center mb-12">
                        अक्सर पूछे जाने वाले सवाल
                    </h2>
                    <div className="flex flex-col gap-4">
                        {[
                            {
                                q: 'Registration kaise karein?',
                                a: 'Home page pe apni category choose karo — 10th, ITI ya Diploma. Phir form bharo, bilkul free hai!'
                            },
                            {
                                q: 'Kya registration bilkul free hai?',
                                a: 'Haan, 100% free! Koi payment nahi, koi hidden charge nahi.'
                            },
                            {
                                q: 'Kin districts mein job milti hai?',
                                a: 'Pune, Mumbai, Gujarat, Nashik — Bihar ke bahar mostly. Kuch local jobs bhi available hain.'
                            },
                            {
                                q: 'Form bharne mein help chahiye?',
                                a: 'Website par chatbot available hai. Ya hamein WhatsApp karo — turant help milegi.'
                            },
                        ].map((faq, i) => (
                            <div key={i} className="bg-dark-300 border border-gray-800 rounded-2xl p-6">
                                <h4 className="text-white font-semibold mb-2">❓ {faq.q}</h4>
                                <p className="text-gray-400 text-sm leading-relaxed">→ {faq.a}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

        </main>
    );
}

export default Contact;